<template>
  <div class="login-container">
    <el-card class="login-card">
      <h2 class="platform-title">数据后台</h2>
      <el-form :model="loginForm" :rules="rules" ref="loginForm">
        <el-form-item prop="username">
          <el-input 
            v-model="loginForm.username" 
            placeholder="用户名"
            @keyup.enter.native="handleLogin">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input 
            v-model="loginForm.password" 
            type="password" 
            placeholder="密码"
            @keyup.enter.native="handleLogin">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            @click="handleLogin" 
            :loading="loading" 
            style="width: 100%">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  export default {
    name: 'Login',
    data() {
      return {
        loginForm: {
          username: '',
          password: ''
        },
        loading: false,
        rules: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      async handleLogin() {
        try {
          await this.$refs.loginForm.validate()
          this.loading = true

          await this.$store.dispatch('user/login', {
            username: this.loginForm.username,
            password: this.loginForm.password
          })

          this.$message.success('登录成功')
          this.$router.push('/dashboard/tt')
        } catch (error) {
          this.$message.error(error.toString())
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style scoped>
  .login-container {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e7eb 100%);
  }

  .login-card {
    width: 400px;
    border-radius: 8px;
    box-shadow:
      0 10px 20px rgba(0, 0, 0, 0.1),
      0 6px 6px rgba(0, 0, 0, 0.1),
      inset 0 -2px 5px rgba(0, 0, 0, 0.1);
  }

  /* Logo样式 */
  .platform-title {
    font-size: 30px;
    font-weight: 500;
    white-space: nowrap;
    letter-spacing: 1.1px;
    text-align: center;
    color: #000;
    position: relative;
    text-shadow:
      0 1px 2px rgba(0, 0, 0, 0.15);
    /* 保留简单的阴影效果 */
  }

  /* 移除 ::before 和 ::after 伪元素，不再需要钢印效果 */
  .platform-title::before,
  .platform-title::after {
    display: none;
  }

  /deep/ .el-input__inner {
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-shadow:
      inset 1px 1px 3px rgba(0, 0, 0, 0.1),
      inset -1px -1px 3px rgba(255, 255, 255, 0.7);
    transition: all 0.3s ease;
  }

  /deep/ .el-input__inner:focus {
    border-color: #409EFF;
    box-shadow:
      0 0 5px rgba(64, 158, 255, 0.5),
      inset 1px 1px 3px rgba(0, 0, 0, 0.1),
      inset -1px -1px 3px rgba(255, 255, 255, 0.7);
  }

  /deep/ .el-button--primary {
    border-radius: 4px;
    font-weight: 600;
    letter-spacing: 1px;
    box-shadow:
      0 2px 4px rgba(0, 0, 0, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
    transition: all 0.3s ease;
  }

  /deep/ .el-button--primary:hover {
    transform: translateY(-1px);
    box-shadow:
      0 4px 8px rgba(0, 0, 0, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
  }

  /deep/ .el-button--primary:active {
    transform: translateY(1px);
    box-shadow:
      0 1px 2px rgba(0, 0, 0, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
  }
</style> 